import { Button, Grid2 as Grid, Stack, Typography } from "@mui/material"
import React from "react"

export const InterestsHeader = ({ title, isSFW, handleToggleCollabInterestType, validation, isTitleVisible = true, ...others }) => {
  return (
    <Grid container alignItems={'center'} {...others} spacing={1.5}>
      {
        isTitleVisible && <Grid item size={{ xs: 12, sm: 8 }}>
          <Stack>
            <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>
            <Typography variant="body2" color="error">{validation}</Typography>
          </Stack>
        </Grid>
      }
      <Grid container item size={{ xs: 12, sm: isTitleVisible ? 4 : 12 }} justifyContent={{ xs: 'center', sm: isTitleVisible ? 'flex-end' : 'center' }}>
        <Stack direction={'row'} gap={1}>
          <Button variant={isSFW ? "outlined" : 'contained'} sx={{ color: !isSFW && '#FFF' }} onClick={() => handleToggleCollabInterestType()}>SFW</Button>
          <Button variant={isSFW ? "contained" : 'outlined'} sx={{ color: isSFW && '#FFF' }} onClick={() => handleToggleCollabInterestType()}>NSFW</Button>
        </Stack>
      </Grid>
    </Grid>
  )
};